import React from 'react';
import { Grid, Dropdown } from 'semantic-ui-react';
import { getLocalidades } from '../../api/Common/localidad';

export const LocationSelector = React.memo(({ 
  provincias, 
  localidades, 
  provinciaValue, 
  localidadValue, 
  onProvinciaChange, 
  onLocalidadChange, 
  disabled = false,
  required = false 
}) => {
  return (
    <>
      <Grid.Column computer={3} mobile={16} tablet={16}>
        <h5>{required ? '*' : ''} Provincia</h5>
        <Dropdown
          search
          disabled={disabled}
          placeholder="Seleccione una provincia"
          name="provincia"
          options={provincias}
          value={provinciaValue}
          onChange={(_, data) => onProvinciaChange(data.value)}
          selection
          fluid
          error={required && provinciaValue === "" ? true : false}
        />
      </Grid.Column>
      <Grid.Column computer={3} mobile={16} tablet={16}>
        <h5>{required ? '*' : ''} Localidad</h5>
        <Dropdown
          search
          disabled={disabled}
          placeholder="Seleccione una localidad"
          name="localidad"
          options={localidades}
          value={localidadValue}
          onChange={(_, data) => onLocalidadChange(data.value)}
          selection
          fluid
          error={required && localidadValue === "" ? true : false}
        />
      </Grid.Column>
    </>
  );
});

